import { apiGet, apiPatch, apiPost } from '../client';
import { BusinessOfferListResponseSchema, BusinessOfferSchema, type BusinessOffer } from '../schemas';

export function listOffers(): Promise<{ data: BusinessOffer[] }> {
  return apiGet('/v1/business/offers', BusinessOfferListResponseSchema);
}

type OfferCommonInput = {
  title: string;
  description: string;
  startsAt: string;
  validUntil: string;
  validDays?: number[];
};

/** Exactly one of the two, matching the server's XOR (`BusinessOfferCreateSchema`). */
export type CreateOfferInput = OfferCommonInput & ({ percentOff: number } | { amountOffCents: number });

export function createOffer(
  input: CreateOfferInput,
  idempotencyKey: string,
): Promise<BusinessOffer> {
  return apiPost('/v1/business/offers', BusinessOfferSchema, input, idempotencyKey);
}

export type PatchOfferInput = {
  title?: string;
  description?: string;
  /** At most one of the two; sending either switches the Oferta's discount type. */
  percentOff?: number;
  amountOffCents?: number;
  startsAt?: string;
  validUntil?: string;
  validDays?: number[] | null;
  isActive?: boolean;
  /** The version the form read; a stale one comes back 409 version_conflict. */
  expectedVersion?: number;
};

export function patchOffer(
  offerId: string,
  input: PatchOfferInput,
  idempotencyKey: string,
): Promise<BusinessOffer> {
  return apiPatch(
    `/v1/business/offers/${encodeURIComponent(offerId)}`,
    BusinessOfferSchema,
    input,
    idempotencyKey,
  );
}
